import React from 'react';

import {
    TextButton,
    Image,
    Text,
    Spacer,
} from '@zillow/constellation';

import {
    Col,
    Container,
    Row,
} from '@zillow/zrs-comet';

import { RMWContext } from 'app/shared/providers/RMWContext';
import puzzleIcon from 'app/shared/images/puzzle.svg';
import { StyledAutoHeightButton, StyledDiv } from './StyledComponents';

const HpppMigrationBlocker = ({ onClick }) => {
    const { paths } = React.useContext(RMWContext);

    return (
        <StyledDiv>
            <Container>
                <Row>
                    <Col xs={0} sm={3} />
                    <Col xs={12} sm={6}>
                        <Image src={puzzleIcon} alt="" />
                        <Spacer marginY="xs" />
                        <Text fontType="h6"><strong>Migrate over to Zillow Rental Manager</strong></Text>
                        <Spacer marginY="xs" />
                        <Text>
                            On June 10th, HotPads landlord and property manager
                            tools transitioned to Zillow Rental Manager.
                            To make this an easy transition, we&apos;ve automatically moved your listings over.
                            You can access them by signing into your Zillow account or creating a new one
                            <Text as="b"> using your same email address. </Text>
                        </Text>
                        <Spacer marginY="sm" />
                        <Text>
                            With Zillow Rental Manager, you&apos;ll get access to our free online tools.
                            And don&apos;t worry—your future rentals will still be listed on the HotPads platform,
                            in addition to Zillow&apos;s and Trulia&apos;s.
                        </Text>
                        <Spacer marginY="sm" />
                        <StyledAutoHeightButton
                            buttonType="primary"
                            onClick={onClick}
                        >
                            <strong>Continue with Zillow Rental Manager</strong>
                        </StyledAutoHeightButton>
                        <Spacer marginY="sm" />
                        <TextButton href={paths.helpPage} as="a">Learn more</TextButton>
                        <Spacer marginY="xs" />
                    </Col>
                    <Col xs={0} sm={3} />
                </Row>
            </Container>
        </StyledDiv>
    );
};

export default HpppMigrationBlocker;
